var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3 offset-md-3 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-fill",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  return _vm.create()
                }
              }
            },
            [_vm._v("Create Gift")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive text-center" },
        [
          _c(
            "l-table",
            {
              staticClass: "table table-light table-bordered table-hover",
              attrs: { columns: _vm.gifts.columns, data: _vm.gifts.data }
            },
            [
              _vm.gifts.data.length
                ? _c(
                    "template",
                    { slot: "table-row" },
                    _vm._l(_vm.gifts.data, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(item.userGiftId))]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "a",
                            { attrs: { href: _vm.makeOnlineUrl(item) } },
                            [_vm._v(_vm._s(_vm.makeOnlineUrl(item)))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group",
                              attrs: { role: "group" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top-center",
                                      value: _vm.tooltips.edit,
                                      expression: "tooltips.edit",
                                      modifiers: { "top-center": true }
                                    }
                                  ],
                                  staticClass: "btn btn-info btn-sm",
                                  on: {
                                    click: function($event) {
                                      return _vm.edit(item)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-edit" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top-center",
                                      value: _vm.tooltips.view,
                                      expression: "tooltips.view",
                                      modifiers: { "top-center": true }
                                    }
                                  ],
                                  staticClass: "btn btn-secondary btn-sm",
                                  on: {
                                    click: function($event) {
                                      return _vm.view(item)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-eye" })]
                              )
                            ]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f74f68a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f74f68a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Gifts/Gifts.vue
// module id = g8BD
// module chunks = 0